/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvatarSourceEnum } from './AvatarSourceEnum';
import {
    AvatarSourceEnumFromJSON,
    AvatarSourceEnumFromJSONTyped,
    AvatarSourceEnumToJSON,
} from './AvatarSourceEnum';
import type { OrganizationTypeDTO } from './OrganizationTypeDTO';
import {
    OrganizationTypeDTOFromJSON,
    OrganizationTypeDTOFromJSONTyped,
    OrganizationTypeDTOToJSON,
} from './OrganizationTypeDTO';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';
import type { PricingPlanDTO } from './PricingPlanDTO';
import {
    PricingPlanDTOFromJSON,
    PricingPlanDTOFromJSONTyped,
    PricingPlanDTOToJSON,
} from './PricingPlanDTO';
import type { OrganizationDTO } from './OrganizationDTO';
import {
    OrganizationDTOFromJSON,
    OrganizationDTOFromJSONTyped,
    OrganizationDTOToJSON,
} from './OrganizationDTO';

/**
 * 
 * @export
 * @interface OrganizationWithRoleDTO
 */
export interface OrganizationWithRoleDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithRoleDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithRoleDTO
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationWithRoleDTO
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithRoleDTO
     */
    paymentStatus: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithRoleDTO
     */
    info?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithRoleDTO
     */
    avatarUrl: string;
    /**
     * 
     * @type {AvatarSourceEnum}
     * @memberof OrganizationWithRoleDTO
     */
    avatarSource: AvatarSourceEnum;
    /**
     * 
     * @type {OrganizationTypeDTO}
     * @memberof OrganizationWithRoleDTO
     */
    organizationType: OrganizationTypeDTO;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationWithRoleDTO
     */
    limitsEnforced: boolean;
    /**
     * 
     * @type {PricingPlanDTO}
     * @memberof OrganizationWithRoleDTO
     */
    pricingPlan: PricingPlanDTO;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof OrganizationWithRoleDTO
     */
    organization: OrganizationDTO;
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof OrganizationWithRoleDTO
     */
    userRole: OrganizationRoleDTO;
}



/**
 * Check if a given object implements the OrganizationWithRoleDTO interface.
 */
export function instanceOfOrganizationWithRoleDTO(value: object): value is OrganizationWithRoleDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('avatarSource' in value) || value['avatarSource'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('limitsEnforced' in value) || value['limitsEnforced'] === undefined) return false;
    if (!('pricingPlan' in value) || value['pricingPlan'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    if (!('userRole' in value) || value['userRole'] === undefined) return false;
    return true;
}

export function OrganizationWithRoleDTOFromJSON(json: any): OrganizationWithRoleDTO {
    return OrganizationWithRoleDTOFromJSONTyped(json, false);
}

export function OrganizationWithRoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationWithRoleDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'created': (new Date(json['created'])),
        'paymentStatus': json['paymentStatus'],
        'info': json['info'] == null ? undefined : json['info'],
        'avatarUrl': json['avatarUrl'],
        'avatarSource': AvatarSourceEnumFromJSON(json['avatarSource']),
        'organizationType': OrganizationTypeDTOFromJSON(json['organizationType']),
        'limitsEnforced': json['limitsEnforced'],
        'pricingPlan': PricingPlanDTOFromJSON(json['pricingPlan']),
        'organization': OrganizationDTOFromJSON(json['organization']),
        'userRole': OrganizationRoleDTOFromJSON(json['userRole']),
    };
}

export function OrganizationWithRoleDTOToJSON(value?: OrganizationWithRoleDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'created': ((value['created']).toISOString()),
        'paymentStatus': value['paymentStatus'],
        'info': value['info'],
        'avatarUrl': value['avatarUrl'],
        'avatarSource': AvatarSourceEnumToJSON(value['avatarSource']),
        'organizationType': OrganizationTypeDTOToJSON(value['organizationType']),
        'limitsEnforced': value['limitsEnforced'],
        'pricingPlan': PricingPlanDTOToJSON(value['pricingPlan']),
        'organization': OrganizationDTOToJSON(value['organization']),
        'userRole': OrganizationRoleDTOToJSON(value['userRole']),
    };
}

